import { ApiService } from './apiService'
import { baseApiUrl } from '../config'
import { AudienceLiftConversion, CreateConversionRequest, UpdateConversionRequest } from '../types/AudienceLiftConversion'
import { AnonEvent } from '../types/Event'

const API_BASE = '/api/v3/audiencelift/conversions'
// Admin panel manages conversions on behalf of another company, so every admin endpoint requires
// a company_id query param (see customer-v3.yaml) - the plain endpoints infer it from the caller's own session.
const ADMIN_API_BASE = '/api/admin/v3/audiencelift/conversions'

export class AudienceLiftConversionService extends ApiService {
    async getConversions(): Promise<AudienceLiftConversion[]> {
        return this.get(API_BASE)
    }

    async getConversionsAdmin(companyId: number): Promise<AudienceLiftConversion[]> {
        return this.get(`${ADMIN_API_BASE}?company_id=${companyId}`)
    }

    async createConversion(payload: CreateConversionRequest): Promise<AudienceLiftConversion> {
        return this.post(API_BASE, payload)
    }

    async createConversionAdmin(companyId: number, payload: CreateConversionRequest): Promise<AudienceLiftConversion> {
        return this.post(`${ADMIN_API_BASE}?company_id=${companyId}`, payload)
    }

    async updateConversion(id: number, payload: UpdateConversionRequest): Promise<AudienceLiftConversion> {
        return this.put(`${API_BASE}/${id}`, payload)
    }

    async updateConversionAdmin(companyId: number, id: number, payload: UpdateConversionRequest): Promise<AudienceLiftConversion> {
        return this.put(`${ADMIN_API_BASE}/${id}?company_id=${companyId}`, payload)
    }

    async removeConversion(id: number): Promise<void> {
        return this.del(`${API_BASE}/${id}`)
    }

    async removeConversionAdmin(companyId: number, id: number): Promise<void> {
        return this.del(`${ADMIN_API_BASE}/${id}?company_id=${companyId}`)
    }

    async getConversionEvents(id: number): Promise<AnonEvent[]> {
        return this.get(`${API_BASE}/${id}/events`)
    }

    async getConversionEventsAdmin(companyId: number, id: number): Promise<AnonEvent[]> {
        return this.get(`${ADMIN_API_BASE}/${id}/events?company_id=${companyId}`)
    }

    async assignConversionEvents(id: number, eventIds: number[]): Promise<AudienceLiftConversion> {
        return this.put(`${API_BASE}/${id}/events`, { eventIds })
    }

    async assignConversionEventsAdmin(companyId: number, id: number, eventIds: number[]): Promise<AudienceLiftConversion> {
        return this.put(`${ADMIN_API_BASE}/${id}/events?company_id=${companyId}`, { eventIds })
    }
}

export const audienceLiftConversionService = new AudienceLiftConversionService(baseApiUrl)
